<template>
  <div class="datetime-datepicker-holder">
    <input
      type="text"
      class="form-control form-control-datepicker"
      ref="input"
      :class="schema.fieldClasses"
      :disabled="disabled"
      :id="getFieldID(schema)"
      :name="schema.inputName"
      :value="date"
      @input="onInput"
    />
    <span v-if="disabled">{{ formatted }}</span>
  </div>
</template>

<script>
  import Flatpickr from 'flatpickr';
  //import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/monthSelect';
  import {Italian} from 'flatpickr/dist/l10n/it';
  import {abstractField} from "vue-form-generator";
  import 'flatpickr/dist/flatpickr.css';
  import {dateformat, date4api, dateFromApi} from '@/providers/fields'

  export default {
    name: 'field-datetime',
    mixins: [abstractField],
    props: {
      options: {},
    },
    data() {return {
      picker: null,
      default_config: {
        enableTime: true,
        enableSeconds: false,
        time_24hr: true,
        altInput: true,
        dateFormat: 'Y-m-d H:i:S',
        altFormat: "j.m.Y H:i",
      },
    }},
    computed: {
      formatted () {
        if (this.date) {
          return dateformat(dateFromApi(this.date), 'D.M.YYYY HH:mm');
        }
      },
      configs () {
        var confs = Object.assign(this.default_config, this.options || {});
        for (let key in confs) {
          if (this.schema.hasOwnProperty(key)) {
            confs[key] = this.schema[key];
          }
        }
        if (typeof this.schema.options === 'object') {
          confs = Object.assign(confs, this.schema.options);
        }
        switch (this.$i18n.i18next.language) {
          case 'it':
            confs.locale = Italian;
            break;
        }
        return confs;
      },
      date () {
        if (this.value && Date.parse(this.value)) {
          return dateformat(this.value, DATE_FORMAT);
        } else {
          return this.value;
        }
      },
    },
    mounted () {
      this.applyConstraints();
      this.applyPicker(false);
    },
    updated () {
      this.applyPicker(false);
    },
    beforeDestroy() {
      if (this.picker) {
        this.picker.destroy();
        this.picker = null;
      }
    },
    methods: {
      applyPicker (redraw = false) {
        if (this.$refs.input && this.$refs.input._flatpickr) {
          if (this.$refs.input._flatpickr.hasOwnProperty('isOpen')) {//if it was not destroyed
            this.picker = this.$refs.input._flatpickr;
          } else {
            if (this.picker === this.$refs.input._flatpickr) {
              this.picker = null;
            }
            delete this.$refs.input._flatpickr;
          }
        }
        if (redraw && this.picker) {
          this.$forceUpdate();
          if (this.$refs.input._flatpickr) {
            this.$refs.input._flatpickr.destroy();
            delete this.$refs.input._flatpickr;
          } else {
            this.picker.destroy();
          }
          this.picker = null;
        } if (!this.picker) {
          this.picker = new Flatpickr(
            this.$refs.input, Object.assign({}, this.configs)
          );
          if (this.value && !this.disabled) {
            var dateValue = dateFromApi(this.value);
            if (this.default_config.minDate) {
              var minRequired = dateFromApi(this.default_config.minDate);
              if (minRequired && dateValue && dateValue < minRequired) {
                //dateValue = minRequired;
              }
            }
            this.picker.setDate(dateValue);
          }
          this.$parent.validate();
        }
      },
      onInput($event) {
        let newvalue = $event.target.value;
        let date = newvalue ? new Date(newvalue.replace(' ', 'T')) : false;
        if (Date.parse(date)) {
          this.value = date4api(date);
        } else if (newvalue) {
          this.value = newvalue;
        }
      },
      applyConstraints () {
        if (this.schema.after && this.model && this.model[this.schema.after]) {
          this.$set(this.default_config, 'minDate', this.model[this.schema.after]);
        } else if (this.schema.minDate) {
          this.$set(this.default_config, 'minDate', this.schema.minDate);
        }
      },
    },
    watch: {
      model: {
        handler () {
          this.applyConstraints();
        },
        deep: true,
      },
      disabled () {
        this.applyPicker(true);
      },
      configs: {
        handler (newvalue) {
          if (!this.picker || !this.picker.config) {
            return;
          }
          var oldvalue = this.picker.config;
          for (let key of Object.keys(newvalue)) {
            if (!oldvalue.hasOwnProperty(key) || oldvalue[key] !== newvalue[key]) {
              this.picker.set(key, newvalue[key]);
            }
          }
          this.applyPicker(true);
        },
        deep: true,
      }
    },
  }
</script>

<style lang="scss">
  div.datetime-datepicker-holder {
    position: relative;
    overflow: hidden;
  }
  input.form-control-datepicker:first-child {
    ~ input[readonly] {
      opacity: 1 !important;
    }
    ~ span {
      display: none;
      position: absolute;
      top: 50%;
      left: 10px;
      opacity: .4;
      transform: translateY(-50%);
    }
    &[disabled] {
      &, + input {
        color: white;
        color: transparent;
        cursor: default;
      }
      ~ span {
        display: inline-block;
        cursor: default;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/mixins/form/Datetime.vue